import classNames from 'classnames';

import type { Question } from '@api/instant_survey/types';
import { Checkbox, Pill } from '@utilities';

import styles from './_index.module.scss';
import { QUESTION_TYPES } from '@api/instant_survey';

interface ResultsProps {
  onToggle: (id: number) => void;
  questions: Question[];
  remainingSlots: number;
  selectedIds: Set<number>;
  selectedQuestions: Question[];
}

const Results = ({
  onToggle,
  questions,
  remainingSlots,
  selectedIds,
  selectedQuestions,
}: ResultsProps) => {
  return (
    <ul className={styles['results-container']}>
      {questions.map((question) => {
        const isMultiSelect = question.type === QUESTION_TYPES.CHECKBOX.value;
        const isSelected = selectedIds.has(question.id);
        const isAlreadyAdded = selectedQuestions.some(({ id }) => id === question.id);
        const isDisabled = isAlreadyAdded || (!isSelected && remainingSlots <= 0);
        const passingAnswers = question.answers
          .filter((answer) => answer.isCorrectAnswer)
          .map((answer) => answer.text);
        const passingValue = passingAnswers.join(' + ');

        return (
          <li key={question.id}>
            <div className={styles['results-question']}>
              <div>
                <div className={styles['results-checkbox-wrapper']}>
                  <Checkbox
                    isChecked={isSelected || isAlreadyAdded}
                    isDisabled={isDisabled}
                    label={
                      <div className={styles['results-label']}>
                        {question.text}{' '}
                        <span
                          className={classNames(styles['results-select-type'], {
                            [styles['is-disabled']]: isDisabled,
                          })}
                        >
                          {isMultiSelect ? 'Multiple select' : 'Single select'}
                        </span>
                      </div>
                    }
                    onChange={() => onToggle(question.id)}
                    value={question.id}
                  />
                </div>
                <span
                  className={classNames(styles['results-caption'], {
                    [styles['is-disabled']]: isDisabled,
                  })}
                >
                  {question.answers.map(({ text }) => text).join(', ')}
                </span>
                {passingValue && (
                  <div>
                    <Pill
                      className={styles['results-passing-value-pill']}
                      isDisabled={isDisabled}
                      value={`${isMultiSelect ? 'Passing set' : 'Passing answer'}: ${passingValue}`}
                    />
                  </div>
                )}
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default Results;
